module.exports = __webpack_public_path__ + "assets/img/eed2-sn.svg";